@if (showLoader()) {
  <div class="fixed inset-0 right-0 z-40 bg-black/5 backdrop-blur"></div>
  <div class="loader z-50 flex flex-col items-center justify-center text-xl">
    <div class="circle mb-4"></div>
    {{ showLoader() }}
  </div>
}
